//importing style
import "react-phone-input-2/lib/style.css";
import "./styles/styles.scss";

//importing react components
import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./tests/reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";

//importing context providers
import { AppDataProvider } from "./context/data";
import { AppStateProvider } from "./context/state";

//importing components
import App from "./App";
import UserContextProvider from "./context/userContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const STRICT = false;

const Body = (
  <I18nextProvider i18n={i18next}>
    <UserContextProvider>
      {/*AppStateProvider is a contextProvider to provide a global state available across all pages*/}
      <AppStateProvider>
        {/*AppDataProvider is a contextProvider to provide a global data available across all pages*/}
        <AppDataProvider>
          {/*Router container for website redirects*/}
          <BrowserRouter>
            {/*Application render*/}
            <App />
          </BrowserRouter>
        </AppDataProvider>
      </AppStateProvider>
    </UserContextProvider>
  </I18nextProvider>
);

root.render(STRICT ? <React.StrictMode>{Body}</React.StrictMode> : <>{Body}</>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
